import { useI18n } from 'vue-i18n';
import { CallSheetService } from '@/shared/utilities/feedback/call-sheet-service';
import { useAuthStore } from '@/core/stores/auth.store';
import { CALL_TARGET } from '@/shared/constants/call';

export function useCallSheet() {
  const { t } = useI18n();

  // Resolve patient contact data when used, rather than keeping another contact snapshot.
  function resolveTarget(target) {
    if (target.kind === CALL_TARGET.CARE_TEAM.kind) {
      const centre = useAuthStore().account.connectedFacilities;
      if (!centre?.telephone) {
        return null;
      }
      return { label: centre.name, number: centre.telephone };
    }
    const call = { label: t(target.labelKey), number: target.number };
    if (target.introKey) {
      call.intro = t(target.introKey);
    }
    if (target.illustration) {
      call.illustration = target.illustration;
    }
    return call;
  }

  function canCallTarget(target) {
    return Boolean(resolveTarget(target)?.number);
  }

  // Open the shared sheet for an available CALL_TARGET entry.
  function callTarget(target) {
    const call = resolveTarget(target);
    if (call) {
      CallSheetService.open(call);
    }
  }

  // Open the shared sheet for a number that is not a CALL_TARGET, such as a care contact.
  function callNumber(label, number) {
    CallSheetService.open({ label, number });
  }

  return { callTarget, callNumber, canCallTarget };
}
